import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Spinner } from './spinner.component';

@NgModule({
  declarations: [
    Spinner
  ],
  imports: [ CommonModule ],
  exports: [
    Spinner
  ],
  providers: [],
})
export class SpinnerModule {}
